
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import CategoriesScreen from './categories';
import SpecialsScreen from './specials';

function Index({ setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    
    
    const [showSpecials, setShowSpecials] = useState(false);
    
    const [showCategories, setshowCategories] = useState(false);
    const [showListProduct, setShowListProduct2] = useState(false);
    
    const [dataBeef, setdataBeef] = useState(false);
  const [dataChicken, setdataChicken] = useState(false);
  const [dataPorck, setdataPorck] = useState(false);
    const [dataFish, setdataFish] = useState(false);
     const [dishs, setdishs] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 325) {
                setdataBeef(item);
            }

            if (item.id === 326) {
                setdataChicken(item);
            }
            if (item.id === 327) {
                setdataPorck(item);
            }
            if (item.id === 328) {
                setdataFish(item);
            }
        });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy}  setShowSpecials={() => {
           
            setShowSpecials(true)
        }}  goCategories={setshowCategories}>
                <div  style={{padding: '0 20px'}}>
                    <div
                        style={{background: 'black', borderRadius: 20}}
                        >
                         <img
                            src={require('./assets/TE_192-01.png')}
                            style={{
                                width: 400,
                                height: 300,
                                objectFit: 'contain',
                                alignSelf: 'center',
                            }}
                        />

                        <div
                            style={{
                                width: '70%',
                                alignSelf: 'center',
                                position: 'relative',
                                zIndex: 9999,
                                margin: '0 auto',
                            }}>
                            <p style={{color: '#fff', textAlign: 'center',}}>
                            <span  style={{
                                color: '#fff',
                                textAlign: 'center',
                              
                                fontWeight: 'bold',
                                fontSize: 16,
                                }}>Escoge 2 Acompañantes:{' '}</span> 
                            Arroz Blanco, Ensalada, Tostones, Maduros, Papas a la Francesa,
                            yuca frita y Frijoles
                            </p>
                            <br />
                            <br />
                            <p
                            style={{
                                color: '#fff',
                                textAlign: 'center',
                            }}>
                                 <b>Choose 2 Sides:</b>
                            White Rice, Salad, Green Plantains, Sweet Plantains, French Fries,
                            fried cassava and Beans
                            </p>
                        </div>

                        <div
            style={{
              width: '100%',
              alignSelf: 'center',
              position: 'relative',
                                zIndex: 9999,
              margin: '20px auto',
                                marginTop: 30,
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',    
                            }}>
                            

                             <div
              onClick={() => {
                 setShowListProduct2(true);
                                        setdishs(dataBeef);
              }}
                                style={{
                  display: 'flex',
                backgroundColor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                width: 330,
                height: 60,
                alignSelf: 'center',
                borderRadius: 5,
                                   boxShadow: "1px 1px 6px #ED6DEC",
                                    marginBottom: 20,
                
              }}>
              <div
                style={{
                  width: '100%',
                                        height: 60,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 3,
                  borderColor: '#FB37FF',
                  borderRadius: 5,
                }}>
                <p
                  style={{
                    fontSize: 30,
                    color: '#FB37FF',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                  }}>
                  {langEng ? 'BEEF' : 'CARNE'}
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                 setShowListProduct2(true);
                                        setdishs(dataChicken);
              }}
              style={{
                backgroundColor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                width: 330,
                height: 60,
                alignSelf: 'center',
                borderRadius: 5, boxShadow: "1px 1px 6px #ED6DEC",
                
                shadowColor: '#ED6DEC',
                shadowOffset: {width: 1, height: 1},
                shadowOpacity: 1,
                shadowRadius: 6,
                elevation: 1,
                marginBottom: 20,
              }}>
              <div
                style={{
                  width: '100%',
                  height: 60,  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 3,
                  borderColor: '#FB37FF',
                  borderRadius: 5,
                }}>
                <p
                  style={{
                    fontSize: 30,
                    color: '#FB37FF',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                  }}>
                  {langEng ? 'CHICKEN' : 'POLLO'}
                </p>
              </div>
                            </div>
                            
                             <div
               onClick={() => {
                 setShowListProduct2(true);
                                        setdishs(dataPorck);
              }}
              style={{
                backgroundColor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                width: 330,
                height: 60,
                alignSelf: 'center',
                borderRadius: 5, boxShadow: "1px 1px 6px #ED6DEC",
                
                shadowColor: '#ED6DEC',
                shadowOffset: {width: 1, height: 1},
                shadowOpacity: 1,
                shadowRadius: 6,
                elevation: 1,
                marginBottom: 20,
              }}>
              <div
                style={{
                  width: '100%',
                  height: 60,  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 3,
                  borderColor: '#FB37FF',
                  borderRadius: 5,
                }}>
                <p
                  style={{
                    fontSize: 30,
                    color: '#FB37FF',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                  }}>
                  {langEng ? 'PORK' : 'CERDO'}
                </p>
              </div>
                            </div>
                             <div
              onClick={() => {
                 setShowListProduct2(true);
                                        setdishs(dataFish);
              }}
              style={{
                backgroundColor: 'white',
                justifyContent: 'center',
                alignItems: 'center',
                width: 330,
                height: 60,
                alignSelf: 'center',
                borderRadius: 5, boxShadow: "1px 1px 6px #ED6DEC",
                
                shadowColor: '#ED6DEC',
                shadowOffset: {width: 1, height: 1},
                shadowOpacity: 1,
                shadowRadius: 6,
                elevation: 1,
                marginBottom: 20,
              }}>
              <div
                style={{
                  width: '100%',
                  height: 60,  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 3,
                  borderColor: '#FB37FF',
                  borderRadius: 5,
                }}>
                <p
                  style={{
                    fontSize: 30,
                    color: '#FB37FF',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                  }}>
                {langEng ? 'FISH' : 'PESCADO'}
                </p>
              </div>
            </div>
                  
            </div>

                       
                        
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                     {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct2}
                    goHome={setshowCategories}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;